// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:26:07

export default {
  "id": "sprunki-3d-shooter",
  "slug": "sprunki-3d-shooter",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/595c1ea056644dca9a08b1db8da8c14d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/595c1ea056644dca9a08b1db8da8c14d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki 3D Shooter",
      "description": "Sprunki 3D Shooter delivers nonstop action as you face off against waves of Sprunkies! Your mission is simple: shoot to survive as long as you can. Run out of ammo? Search the battlefield for scattered rounds to keep the fight alive. Gear up and prepare to take on the Sprunkies—can you last the challenge?",
      "instructions": "Use WASD to move around and left mouse click to shoot!",
      "genres": [
        "Agility",
        "Shooter"
      ],
      "tags": [
        "1player",
        "3d",
        "aim",
        "shoot-em-up",
        "weapons"
      ]
    },
    "zh-CN": {
      "title": "Sprunki 3D 射击游戏",
      "description": "Sprunki 3D 射击游戏为你带来不间断的刺激战斗，你将对抗一波又一波的 Sprunkies！你的任务很简单：射击以尽可能长时间地生存。弹药耗尽？在战场上寻找散落的子弹，让战斗继续。装备齐全，准备迎接 Sprunkies 的挑战——你能坚持多久？",
      "instructions": "使用WASD键移动，左键点击射击！",
      "genres": [
        "敏捷性",
        "射击"
      ],
      "tags": [
        "1玩家",
        "3D",
        "瞄准射击",
        "射击游戏",
        "武器"
      ]
    },
    "zh-TW": {
      "title": "Sprunki 3D 射擊遊戲",
      "description": "Sprunki 3D Shooter 帶來不斷的動作，讓你對抗一波又一波的 Sprunkies！你的任務簡單：射擊以生存最長。彈藥耗盡？在戰場上尋找四處散落的子彈以維持戰鬥。裝備起來，準備迎接 Sprunkies 的挑戰——你能夠堅持到最後嗎？",
      "instructions": "使用WASD鍵盤移動，並用左鍵擊發！",
      "genres": [
        "敏捷度",
        "射手"
      ],
      "tags": [
        "1人操作",
        "3D",
        "瞄准",
        "射擊遊戲",
        "武器"
      ]
    },
    "zh-HK": {
      "title": "Sprunki 3D 枪戰遊戲",
      "description": "Sprunki 3D Shooter 帶來連續不停動作，與無盡的 Sprunkies 阵容對決！你的任務簡單：射擊以維持生存最長時間。彈藥用盡？搜尋戰場上散落的子彈以保持戰鬥力。裝備好，準備對抗 Sprunkies—你能應付這個挑戰嗎？",
      "instructions": "使用WASD移動和用左鍵按鍵發射！",
      "genres": [
        "敏捷度",
        "射手"
      ],
      "tags": [
        "1人遊玩",
        "3D",
        "瞄准",
        "射擊遊戲",
        "武器"
      ]
    },
    "ja": {
      "title": "スプリンキー3Dシューター",
      "description": "Sprunki 3D Shooterは、あなたがSprunkiesの波に立ち向かう際に連続的なアクションを提供します。あなたのミッションはシンプルです：生存するために尽可能長く撃ち続けます。弾薬が切れたら？戦場を探して散らばった弾薬を見つけ、戦いを続けます。準備を整え、Sprunkiesに挑戦する準備をしましょう——この挑戦に耐えられるでしょうか？",
      "instructions": "WASDを使って移動し、左クリックで射撃！",
      "genres": [
        "アギリティ",
        "シューター"
      ],
      "tags": [
        "1プレイヤー",
        "3D",
        "アミ",
        "シューティングエムアップ",
        "武器"
      ]
    },
    "ko": {
      "title": "스프런키 3D 쏘샷터",
      "description": "스프런키 3D 셔터는 Sprunkies와의 끊임없는 전투로 진정한 액션을 제공합니다! 여러분의 임무는 간단합니다: 지속적으로 쏘아 생존하십시오. 탄약이 다 났을 때? 전장에서 흩어진 탄환을 찾아 전투를 계속하십시오. 장비를 갈고 Sprunkies와 맞서 싸워 보세요—이 도전에 견딜 수 있을까요?",
      "instructions": "WASD를 사용하여 이동하고 왼쪽 마우스 클릭으로 쏘세요!",
      "genres": [
        "기동력",
        "쏠쏠枪"
      ],
      "tags": [
        "1플레이어",
        "3D",
        "정확도",
        "쏘아오라",
        "무기"
      ]
    },
    "fr": {
      "title": "Sprunki 3D Shooter",
      "description": "Sprunki 3D Shooter offre une action ininterrompue alors que vous affrontez des vagues de Sprunkies ! Votre mission est simple : tirez pour survivre le plus longtemps possible. Épuisez votre munition ? Cherchez sur le champ de bataille des balles éparpillées pour maintenir le combat. Équipez-vous et préparez-vous à affronter les Sprunkies : pouvez-vous tenir le challenge ?",
      "instructions": "Utilisez les touches WASD pour vous déplacer et cliquez avec le bouton gauche de la souris pour tirer !",
      "genres": [
        "Agilité",
        "tireur"
      ],
      "tags": [
        "1 joueur",
        "3D",
        "visée",
        "tirelire",
        "armes"
      ]
    }
  }
};
